// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-col[data-v-5762bda5] {\n  border-radius: 4px;\n  margin-left: 20px;\n}\n.el-row[data-v-5762bda5] {\n  margin-bottom: 20px;\n}\n.text-input-label[data-v-5762bda5] {\n  display: inline-block;\n  width: 200px;\n  height: 36px;\n  text-align: right;\n  padding-top: 10px;\n  padding-right: 20px;\n}", ""]);
// Exports
module.exports = exports;
